import type { IconNode } from '../types';

/**
 * @name skirt
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iMTIiIGhlaWdodD0iNCIgeD0iNiIgeT0iMyIgLz4KICA8cGF0aCBkPSJNNiA3YzAgMS43LS40IDMuMy0xIDQuNEMzLjggMTMuNiAyIDE3IDIgMTdzMS44IDEuMiA0LjUgMi4xIiAvPgogIDxwYXRoIGQ9Im04IDE2LTIgNHMyLjcgMSA2IDEgNi0xIDYtMWwtMi00IiAvPgogIDxwYXRoIGQ9Ik0xNy41IDE5LjFDMjAuMiAxOC4yIDIyIDE3IDIyIDE3cy0xLjgtMy40LTMtNS42Yy0uNi0xLjEtMS0yLjctMS00LjQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/skirt
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const skirt: IconNode = [
  ['rect', { width: '12', height: '4', x: '6', y: '3', key: 'bdw6vj' }],
  ['path', { d: 'M6 7c0 1.7-.4 3.3-1 4.4C3.8 13.6 2 17 2 17s1.8 1.2 4.5 2.1', key: 'qouldt' }],
  ['path', { d: 'm8 16-2 4s2.7 1 6 1 6-1 6-1l-2-4', key: '1gwzr8' }],
  [
    'path',
    { d: 'M17.5 19.1C20.2 18.2 22 17 22 17s-1.8-3.4-3-5.6c-.6-1.1-1-2.7-1-4.4', key: 'wxgezq' },
  ],
];

export default skirt;
